import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: []
})
export class ConfigComponent implements OnInit {
  name: any = '';
  // objects
  country: any = {};
  countryList: Array<any> = [];
  selectedCountry: any = {};
  // for search
  qString: any = 'qString';
  type: string = 'list';
  AddForm: FormGroup;
  EditForm: FormGroup;
  // pagination and rowcount
  pager: any = {};
  noOfPages: any;
  currentPage = 1;
  rowCount = 0;
  totalRecords = 0;
  selectedRowCount = 10;
  selectedRecordCount = 10;

  constructor(private route: ActivatedRoute, private fb: FormBuilder, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.AddForm = fb.group({
      'name': [null, Validators.required],
      'description': [null, Validators.required]
    });
    this.EditForm = fb.group({
      'name': [null, Validators.required],
      'description': [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.name = params['name'];
    });
    this.onViewSelect('list');
    this.setPage(1);
  }

  onViewSelect(value: any) {
    switch (value) {
      case 'add':
        this.type = 'add';
        this.AddForm.reset();
        break;
      case 'edit':
        this.type = 'edit';
        break;
      case 'view':
        this.type = 'view';
        break;
      case 'list':
        this.type = 'list';
        break;
      default:
        this.type = 'list';
        break;
    }
  }

  setPage(currentPage: number) {
    this.currentPage = currentPage;
  }

  onAddRecord(model: any) {
  }

  onEditRecord(model: any) {
    model.countryId = this.country.countryId;
  }

  onDeleteRecord(id: any) {
  }

  onRecordByID(id: any, view: any) {
  }

  onSearchRecord(key: any) {
    if (key === '') {
      this.qString = 'qString';
      this.setPage(1);
    }
    else {
      this.qString = key;
    }
  }

  // pagination methods
  onRecordCountChange(records: number) {
    this.selectedRowCount = records;
    this.setPage(this.currentPage);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/config/config.component.ts